import { z } from 'zod';

export type PagedResult<T> = z.infer<ReturnType<typeof PagedResult<T>>>;

export const PagedResult = <T>(itemType: z.ZodType<T>) =>
  z.object({
    items: z.array(itemType),
    hasMore: z.boolean(),
    devicesWithMore: z.string().array().nullish(),
  });
